import React from 'react';
import { Box, Typography } from '@material-ui/core';

import FormikCheckbox from 'src/components/formik/FormikCheckbox';
import FormikInput from 'src/components/formik/FormikInput';
import FormikConfigForm from 'src/components/formik/FormikConfigForm';

function ScheduledEmailForm({
  onSubmit,
  onClose,
  scheduledEmail = {},
  completedTaskId,
  tertiaryButtonLabel
}: any) {
  const { timeZone } = Intl.DateTimeFormat().resolvedOptions();

  const fieldsConfig = [
    {
      name: 'timeZone',
      defaultValue: timeZone,
    },
    {
      component: (children: any) => (
        <Box>
          <Typography variant="h5">Recurrence</Typography>
          <Box pl={1} pt={1}>
            {children}
          </Box>
        </Box>
      ),
      containerProps: { spacing: 0 },
      gridProps: { md: 6, xs: 12 },
      fields: [
        {
          containerProps: { spacing: 0 },
          gridProps: { md: 6, xs: 12 },
          fields: [
            {
              name: 'monday',
              component: () => (
                <FormikCheckbox
                  label="Monday"
                  name="monday"
                  fullWidth
                />
              ),
            },
            {
              name: 'tuesday',
              component: () => (
                <FormikCheckbox
                  label="Tuesday"
                  name="tuesday"
                  fullWidth
                />
              ),
            },
            {
              name: 'wednesday',
              component: () => (
                <FormikCheckbox
                  label="Wednesday"
                  name="wednesday"
                  fullWidth
                />
              ),
            },
            {
              name: 'thursday',
              component: () => (
                <FormikCheckbox
                  label="Thursday"
                  name="thursday"
                  fullWidth
                />
              ),
            },
            {
              name: 'friday',
              component: () => (
                <FormikCheckbox
                  label="Friday"
                  name="friday"
                  fullWidth
                />
              ),
            },
          ]
        },
        {
          containerProps: { spacing: 0 },
          gridProps: { md: 6, xs: 12 },
          fields: [
            {
              name: 'saturday',
              component: () => (
                <FormikCheckbox
                  label="Saturday"
                  name="saturday"
                  fullWidth
                />
              ),
            },
            {
              name: 'sunday',
              component: () => (
                <FormikCheckbox
                  label="Sunday"
                  name="sunday"
                  fullWidth
                />
              ),
            },
          ]
        },
        {
          name: 'time',
          component: () => (
            <Box mt={1}>
              <FormikInput
                fullWidth
                label="Time"
                name="time"
                type="time"
                helperText={`Time zone: ${timeZone}`}
              />
            </Box>
          ),
          defaultValue: '8:30',
        },
      ],
    },
  ];

  return (
    <FormikConfigForm
      fieldsConfig={fieldsConfig}
      result={{
        ...scheduledEmail,
        completedTaskId,
      }}
      onSubmit={onSubmit}
      primaryButton={{
        label: 'Schedule',
      }}
      tertiaryButton={{
        label: tertiaryButtonLabel || 'Back',
        onClick: onClose
      }}
    />
  );
}

export default ScheduledEmailForm;
